import { createSlice } from "@reduxjs/toolkit";
import CommonMaster from "../../ts/models/CommonMaster";
import Service from "../../ts/models/Service";
import InfoQuestion from "../../ts/models/InfoQuestion";

type InitialState = {
  ethnicGroups: CommonMaster[];
  genders: CommonMaster[];
  races: CommonMaster[];
  relationships: CommonMaster[];
  services: Service[];
  totalServicesCount: number;
};

const initialState: InitialState = {
  ethnicGroups: [],
  genders: [],
  races: [],
  relationships: [],
  services: [],
  totalServicesCount: 0,
};

const masters = createSlice({
  name: "masters",
  initialState,
  reducers: {
    fetchAllMaster: (state, action) => {
      const { ethnicGroups, genders, races, relationships, services } =
        action.payload;

      state.ethnicGroups = ethnicGroups || [];
      state.genders = genders || [];
      state.races = races || [];
      state.relationships = relationships || [];
      state.services = services || [];
    },
  },
});

export const mastersActions = masters.actions;

export default masters.reducer;
